import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import JustificanteAusenciaForm from "./JustificanteAusenciaForm";

export default function JustificanteAusenciaDialog({ open, student, onClose }) {
  if (!student) return null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="sm:max-w-4xl max-h-[92vh] overflow-y-auto"
        data-testid="justificante-ausencia-dialog"
      >
        <DialogHeader>
          <DialogTitle>Justificante de Ausencia</DialogTitle>
        </DialogHeader>
        <JustificanteAusenciaForm
          students={[student]}
          defaultStudentId={student.id}
          lockStudent
        />
      </DialogContent>
    </Dialog>
  );
}
